function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  x1: "92.758%",
  y1: "-30.769%",
  x2: "11.763%",
  y2: "111.765%",
  id: "a"
}, React.createElement("stop", {
  stopColor: "#61BEBC",
  stopOpacity: 0,
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#F2F4F6",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "83.096%",
  y1: "-4.895%",
  x2: "29.326%",
  y2: "117.483%",
  id: "d"
}, React.createElement("stop", {
  stopColor: "#7CC9C8",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#61BEBC",
  offset: "100%"
})), React.createElement("circle", {
  id: "b",
  cx: 74,
  cy: 74,
  r: 74
}), React.createElement("filter", {
  x: "-29.7%",
  y: "-23.6%",
  width: "159.5%",
  height: "159.5%",
  filterUnits: "objectBoundingBox",
  id: "c"
}, React.createElement("feOffset", {
  dy: 8,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 12,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), React.createElement("feComposite", {
  in: "shadowBlurOuter1",
  in2: "SourceAlpha",
  operator: "out",
  result: "shadowBlurOuter1"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.252634095 0 0 0 0 0.258173388 0 0 0 0 0.292517007 0 0 0 0.1231601 0",
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1"
}), React.createElement("feOffset", {
  dy: 1,
  in: "SourceAlpha",
  result: "shadowOffsetOuter2"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 2,
  in: "shadowOffsetOuter2",
  result: "shadowBlurOuter2"
}), React.createElement("feComposite", {
  in: "shadowBlurOuter2",
  in2: "SourceAlpha",
  operator: "out",
  result: "shadowBlurOuter2"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.137652853 0",
  in: "shadowBlurOuter2",
  result: "shadowMatrixOuter2"
}), React.createElement("feMerge", null, React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), React.createElement("feMergeNode", {
  in: "shadowMatrixOuter2"
}))));

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 107.5,
  cy: 107.5,
  r: 91.5
});

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(34 32)"
}, React.createElement("mask", {
  id: "e",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#b"
})), React.createElement("use", {
  fill: "#000",
  filter: "url(#c)",
  xlinkHref: "#b"
}), React.createElement("circle", {
  stroke: "#FFF",
  strokeWidth: 8,
  strokeLinejoin: "square",
  fill: "url(#d)",
  cx: 74,
  cy: 74,
  r: 70
}), React.createElement("rect", {
  fill: "#FFF",
  mask: "url(#e)",
  x: 25,
  y: 99,
  width: 99,
  height: 80,
  rx: 33
}), React.createElement("circle", {
  fill: "#FFF",
  mask: "url(#e)",
  cx: 74.5,
  cy: 61.5,
  r: 28.5
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 215,
    height: 215,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("g", {
    fill: "url(#a)",
    opacity: 0.4
  }, _ref2, React.createElement("circle", {
    style: {
      mixBlendMode: 'multiply'
    },
    cx: 107.5,
    cy: 107.5,
    r: 107.5
  })), _ref3));
};

export default __webpack_public_path__ + 'static/media/icon-account-setup.00312a72.svg';
export { SvgComponent as ReactComponent };


// WEBPACK FOOTER //
// ./src/images/icon-account-setup.svg